import { Component, OnInit } from '@angular/core';
import { BreakpointService, EventBusService, EventType, SessionService } from '@services';
import { BaseComponent } from '../../../../base.component';
import { Permissions, Roles } from '@enums';
import { MatDialog } from '@angular/material/dialog';
import { SupportModalComponent } from '../../support-modal/support-modal.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent extends BaseComponent implements OnInit {
  public isInnerPage = false;
  public canAccessSettings = false;

  constructor(
    protected override sessionService: SessionService,
    protected override breakpointService: BreakpointService,
    private eventBusService: EventBusService,
    private dialog: MatDialog,
  ) {
    super(sessionService, breakpointService);
    this.checkDesktop();
    this.eventBusService.on(EventType.IsSettingsInnerPage).subscribe({
      next: (option) => {
        this.isInnerPage = Boolean(option.inner);
      },
    });
  }

  ngOnInit(): void {
    this.getUserData();
  }

  loadData(): void {
    const hostRoles = [
      Permissions.ManageUsers,
      Permissions.ManageSettings,
      Permissions.ImportExport,
      Permissions.ManageSettingsGeneral,
      Permissions.ManageSettingsSurveys,
      Permissions.ManageSettingsCategories,
      Permissions.ManageSettingsWebhooks,
    ];
    this.canAccessSettings =
      this.user.role === Roles.Admin || hostRoles.some((r) => this.user.permissions?.includes(r));
  }

  public openAboutModal(): void {
    this.dialog.open(SupportModalComponent, {
      width: '100%',
      maxWidth: 768,
      panelClass: ['modal', 'support-modal'],
    });
  }
}
